module.exports = __webpack_public_path__ + "static/media/estate-clarity-mockup-2.ff655366.jpg";